import { HttpClient } from '@angular/common/http';
import { Component, Input, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { Subscription, switchMap, timer } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../../../services/auth.service';
import { BucketService } from '../../../services/bucket.service';
import { UserService } from '../../../services/user.service';

@Component({
  selector: 'app-website-dialog',
  templateUrl: './website-dialog.component.html',
  styleUrl: './website-dialog.component.scss',
})
export class WebsiteDialogComponent implements OnDestroy {
  @Input() bucketId!: string;

  form: FormGroup;
  loading: boolean = true;

  isCrawlerRunning: boolean = false;
  numWebsitesFound: number = 0;
  timerSubscription?: Subscription;

  constructor(
    protected dialogRef: NbDialogRef<WebsiteDialogComponent>,
    protected authService: AuthService,
    protected userService: UserService,
    protected bucketService: BucketService,
    protected fb: FormBuilder,
    protected nbToastrService: NbToastrService,
    protected http: HttpClient
  ) {
    var expression =
      /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/i;

    this.form = this.fb.group({
      urls: ['', Validators.pattern(expression)],
      refresh_cycle: ['NEVER', Validators.required],
      type: ['urls', Validators.required],
    });

    this.startPolling();
  }

  ngOnDestroy(): void {
    this.stopPolling();
  }

  async onSubmit() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.loading = true;
    this.http
      .post(`${environment.filesBackend}/process/${this.form.value.type}`, {
        urls: [this.form.value.urls],
        refresh_cycle: this.form.value.refresh_cycle,
        bucket_id: this.bucketId,
      })
      .subscribe((res: any) => {
        console.log(res);
        if (this.form.value.type === 'recursive-urls') {
          this.startPolling();
        } else {
          this.bucketService.getBucketEntries(this.bucketId).subscribe();
          this.dialogRef.close();
        }
      });
  }

  startPolling() {
    this.timerSubscription = timer(0, 2000)
      .pipe(switchMap(() => this.bucketService.getFileProcessingStatus()))
      .subscribe((data: any) => {
        this.loading = false;
        this.isCrawlerRunning = data.data.length > 0;
      });
  }

  stopPolling() {
    this.timerSubscription?.unsubscribe();
    this.bucketService.getBucketEntries(this.bucketId).subscribe(() => {
      this.dialogRef.close();
    });
  }

  showInputError(name: string) {
    return this.form.get(name)?.touched && this.form.get(name)?.invalid;
  }
}
